// extracted by mini-css-extract-plugin
export default {"modal":"kWtjzlXROBgGj17doBQY","content":"QBY_LvNMpDRY1uOI5OGf"};